// extracted by css-extract-rspack-plugin
export default {"Box":"chart-link-module__Box__v88R3oe","PotentiallyDirty":"chart-link-module__PotentiallyDirty__iyVegOv"};